
// DIALOGS 
import data_input from './data_input.js';

export default [
	data_input
];


